import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Guoyi Zhang (Garrick)</span>,
            a Software Engineer with hands-on experience in building scalable healthcare software.

            <br /> <br />
            I got my Master's degree in Computer Science at Northeastern University, Go Huskies!

            <br /> <br />
            I’m a builder at heart—comfortable owning projects end-to-end, from system architecture to hands-on coding.

            <br /> <br />
            Skilled in <span className="purple">Infra, frontend, and backend tech stacks</span>, I thrive in team environments, delivering scalable and reliable solutions through strong collaboration and ownership.

            <br /> <br />
            Enjoy:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Video Games, BF6? Yes!
            </li>
            <li className="about-activity">
              <ImPointRight /> Maine! Maine! Maine!
            </li>
            <li className="about-activity">
              <ImPointRight /> Ramen! Ramen! Ramen!
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Everything comes with a cost."
          </p>
        <footer className="blockquote-footer"></footer>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
